<div class="container" *ngIf="myreturns$ | async">
  <div class="row">
    <div class="s6">
      <div class="btn-group--fill">
        <button
          *ngIf="processedImage == 0 && totalFrames == 0"
          class="btn btn-secondary"
          (click)="exportMyReturn()"
          type="button"
          mat-button
        >
          Print My Return
        </button>
        <div class="container text-center" *ngIf="processedImage > 0 || totalFrames > 0">
          <p>Generating PDF Report. Processing {{ processedImage }} of {{ totalFrames }}</p>
        </div>
      </div>
    </div>
    <div class="s6 container text-center">
      <span style="float:right;font-weight: bold;"> RMA : {{ returnAuthorization }}</span>
    </div>
  </div>
</div>
